<template>
    <div id="incidentCounter">
        <div id="markerCount"></div>
        <div id="incidentLabel">INCIDENTS</div>
    </div>
</template>

<style scoped>
#incidentCounter {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 1000;
}
#markerCount {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
#incidentLabel {
    background-color: #ffd63a;
    font-weight: bold;
    padding: 5px;
    margin-top: 7px;
    border: 2px solid black;
}
@media screen and (max-width: 700px) {
  #incidentCounter, #incidentLabel { display: none; }
}
</style>

<style>
.markerCountDigit {
    background-color: #ffd63a;
    border: 2px solid black;
    padding-top: 12px;
    padding-bottom: 12px;
    font-weight: bold;
}
</style>

<script>
export default {
  name: 'IncidentCounter',
  props: ['activeMarkers'],
  watch: {
    activeMarkers() {
      const text = document.getElementById('markerCount');
      text.innerHTML = '';
      const string = this.activeMarkers.length.toString();
      string.split('');
      let i = 0;
      const { length } = string;
      const widthValue = 100 / (length);
      for (i; i < length; i += 1) {
        text.innerHTML += `<span class='markerCountDigit' style='width:calc(${widthValue}% - 5px)'>${string[i]}</span>`;
      }
    },
  },
};
</script>
